<!-- Modal Container -->
<template>
  <transition name="modal-fade" class="modal-fade">
    <div class="modal-backdrop">
      <form @submit.prevent="deleteKeyword" action="#"  method="post">
      <div class="delete-modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
        <header class="modal-header">
          <slot name="header">           
            {{actionToBePerformed}}
            <div class="closeButton">
              <!-- <button type="button" class="btn" @click="close">Close</button> -->
            </div>
          </slot>
        </header>
        <section class="delete-modal-body">
          <div>{{confirmationMessage}}</div>          
        </section>
        <footer class="modal-footer">
            <slot name="footer">
              <button type="button" class="btn btn-primary" @click="close">Cancel</button>
              <input type="submit" class="btn btn-primary" value="Yes, Proceed">
          </slot>
        </footer>
      </div>
      </form>
    </div>
  </transition>
  <!-- Modal Container end -->
</template>
<script>
  export default {
    name: 'modal',
    props: ['gRowObj', 'actionToBePerformed', 'confirmationMessage', 'isDeleteConfirmationVisible'],
    data () {
      return {
        actionToBePerformed: 'Delete Keyword'
      }
    },
    methods: {
      close () {
        console.log('closing the modal')
        this.submitted = false
        this.$emit('close')
      },
      deleteKeyword (e) {
        // console.log(e)
        if (this.actionToBePerformed === 'Delete Message') {
          this.$emit('deleteMessage')
        } else if (this.actionToBePerformed === 'Delete Resources') {
          this.$emit('deleteResources')
        } else if (this.actionToBePerformed === 'Delete Prompt') {
          this.$emit('deletePrompt')
        } else if (this.actionToBePerformed === 'Delete Customer') {
          this.$emit('deleteCustomer')
        } else if (this.actionToBePerformed === 'Deactivate Customer') {
          this.$emit('deactiveCustomer')
        } else if (this.actionToBePerformed === 'Activate Customer') {
          this.$emit('activeCustomer')
        } else if (this.actionToBePerformed === 'Publish Resource' || this.actionToBePerformed === 'Deactivate Resource' || this.actionToBePerformed === 'Draft Resource') {
          this.$emit('activeResource')
        } else if (this.actionToBePerformed === 'Delete Link') {
          this.$emit('deleteLink')
        } else if (this.actionToBePerformed === 'Deactivate Link') {
          this.$emit('deactiveLink')
        } else if (this.actionToBePerformed === 'Activate Link') {
          this.$emit('activeLink')
        } else if (this.actionToBePerformed === 'Draft Campaign' || this.actionToBePerformed === 'Activate Campaign') {
          this.$emit('updateOpportunityStatus')
        } else if (this.actionToBePerformed === 'Delete Campaign') {
          this.$emit('deleteOpportunity')
        } else if (this.actionToBePerformed === 'Delete Reengagement') {
          this.$emit('deleteReengagement')
        } else if (this.actionToBePerformed === 'Delete Nudge Template') {
          this.$emit('deleteNudgeTemplate')
        } else if (this.actionToBePerformed === 'Delete Phrase') {
          this.$emit('deletePhrase')
        } else if (this.actionToBePerformed === 'Delete Scout JOR mapping') {
          this.$emit('deleteScoutJORMapping')
        } else if (this.actionToBePerformed === 'Delete Scout JOR mapping stage') {
          this.$emit('deleteMappingFromDB')
        } else if (this.actionToBePerformed === 'Delete Nlp Topic mapping') {
          this.$emit('deleteNlpTopicMapping')
        } else if (this.actionToBePerformed === 'Delete Label Conversation Mapping') {
          this.$emit('deleteMappingFromDB')
        } else {
          this.$emit('deleteKeyword')
        }
      }
    }
  }
</script>
<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .delete-modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    position:absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);    
    height:200px;    
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
    display: inline-block;
  }

  .modal-header {
    border-bottom: 1px solid #eeeeee;
    text-align: center;
    font-size: 18px;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
  }

  .delete-modal-body {
    position: relative;
    padding: 20px 10px;
    min-height: 70px;    
  }

  .btn-close {
    border: none;
    font-size: 20px;
    padding: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #0D9488;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #0D9488;
    border: 1px solid #0D9488;
    border-radius: 2px;
  }
  .modal-fade-enter,
  .modal-fade-leave-active {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease
  }
  .closeButton {
    position:absolute;
    left:92%;
    top:-1%;
    font-weight: bold;
  }
  .text-red {
    color: red
  }
</style>


// WEBPACK FOOTER //
// deleteConfirmation.vue?d58d1d9c